
import Vue from 'vue'
import axios from "axios";

export default Vue.extend({
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      loginFailed: false,
    };
  },
  methods: {
    async login() {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const url = `${BASE_URL}/token-auth/`;
      const data = new URLSearchParams()
      data.set("username", this.username)
      data.set("password", this.password)
      try {
        const response = await axios.post(url, { username: this.username, password: this.password });
        const authHeader = `${response.data.token_type} ${response.data.token}`;
        window.sessionStorage.setItem("auth-header", authHeader);
        axios.defaults.headers.common["Authorization"] = authHeader;
        const next = this.$route.query["next"];
        if (typeof next === "string") {
          this.$router.replace({ name: next });
        }
      } catch {
        this.loginFailed = true;
      }
    }
  }
})
